import * as React from 'react';
import * as styles from './styles.scss';
import { datePlaceholder } from 'owa-locstrings/lib/strings/dateplaceholder.locstring.json';
import { DropdownDatePicker } from 'owa-datepicker';
import { observer } from 'mobx-react-lite';
import type { SearchFilterOption } from 'owa-timestream-asset-search';
import loc from 'owa-localize';
import useDatePickerSearchRefinerState from '../../hooks/useDatePickerSearchRefinerState';

export default observer(function DatePickerSearchRefiner({
    option,
}: {
    option: SearchFilterOption;
}) {
    const { onChange } = useDatePickerSearchRefinerState({ option });

    if (option.type !== 'DatePicker') {
        return null;
    }

    return (
        <DropdownDatePicker
            className={styles.datePicker}
            disableAutoFocus={true}
            label={option.label}
            onSelectDate={onChange}
            placeholder={loc(datePlaceholder)}
            value={option.value}
            styles={{
                root: {
                    selectors: {
                        '& label': {
                            // there isn't currently a mergestyles classname to target the label
                            fontSize: 12,
                        },
                    },
                },
            }}
        />
    );
});
